import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { PrivilegeService } from '../../modules/auth/services/privilege.service';

@Directive({
  selector: '[appHasAnyPrivilege]',
})
export class HasAnyPrivilegeDirective {
  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private privilegeService: PrivilegeService,
  ) {}

  @Input('appHasAnyPrivilege') privileges: any;

  // eslint-disable-next-line @angular-eslint/use-lifecycle-interface
  ngOnInit(): void {
    this.privilegeService.initPrivilegeCodes();
    const privilegesArray = this.privileges.split(',').map((item: any) => {
      return item.trim();
    });
    if (this.privilegeService.hasAnyPrivilege(privilegesArray)) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }

  /**
   * Use -> *appHasAnyPrivilege="'TEST.PRIVILEGE.15, ...'"
   *
   */
}
